import { IBaoCaoRequest } from "../../../model/request/bao-cao/IBaoCaoRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IBaoCaoBaseActionTypes<T> {
  selectedTabId: string;
  data: T;
}
export const eBaoCaoActionsObj = {
  LOAD_START: {} as IBaoCaoBaseActionTypes<IBaoCaoRequest>,
  LOAD_SUCCESS: {} as IBaoCaoBaseActionTypes<string>,
  LOAD_ERRR: {} as IBaoCaoBaseActionTypes<string>,

  EXPORT_BAO_CAO_START: {} as IBaoCaoBaseActionTypes<IBaoCaoRequest>,
  EXPORT_BAO_CAO_SUCCESS: {} as IBaoCaoBaseActionTypes<null>,
  EXPORT_BAO_CAO_ERROR: {} as IBaoCaoBaseActionTypes<string>,

  SHOW_HIDE_FILTER: {} as IBaoCaoBaseActionTypes<boolean>,

  CHANGE_REQUEST: {} as IBaoCaoBaseActionTypes<any>,
  CHANGE_BAOCAO_ID_SELECTED: 0,

  ADD_NEW_TAB: undefined,
  REMOVE_TAB: "",
  CHANGE_SELECTED_TAB: "",
  CHANGE_TITLE_TAB: {} as IBaoCaoBaseActionTypes<string>,
};
export const eBaoCaoActionTypeIds = generateActionTypeIds(
  eBaoCaoActionsObj,
  "BAO_CAO"
);
export type IBaoCaoActionTypes = IGenericActionType<
  typeof eBaoCaoActionsObj,
  "BAO_CAO"
>;
